export function SelectCourse() {
  const form = document.querySelector('.wpcf7 form')

  if (form) {
    const select = form.querySelector('[name="your-course"]')

    form.addEventListener('submit', function (e) {
      const oldTip = form.querySelector('.custom-valid-tip')
      if (oldTip) oldTip.remove()

      if (select.value === '' || select.value === 'Wybierz kurs') {
        e.preventDefault()

        setTimeout(() => {
          const span = document.createElement('span')
          span.className = 'wpcf7-not-valid-tip custom-valid-tip'
          span.setAttribute('aria-hidden', 'true')
          span.innerText = 'Proszę wypełnić to pole.'
          select.insertAdjacentElement('afterend', span)

          select.classList.add('wpcf7-not-valid')
        }, 100)
      }
    })
  }
}
